<template>
  <div>
    <div class="overlay">
      <div v-if="$route.name === 'Home'">
        <div class="overlay-body">
          <div>
            <p class="frail-text">{{todayDate}}月度の<br />基本データ<br />健康度チェック<br />をしましょう</p>
          </div>
              <div class="tap-contents">
                <div @click="homeback" class="back-img btn-img">
                  <img src="@/assets/meal_history/アセット 20@2x.png" />
                </div>
                <router-link to="/frailtyRiskCheck">
                <div class="record-img btn-img">
                  <img src="@/assets/meal_history/アセット 21@2x.png" />
                </div>
                </router-link>
              </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "FrailCheckAlert",
  data() {
    return {
      todayDate: moment().format("M"),
    }
  },
  methods: {
    homeback() {
      this.$emit("home-back");
    }
  },

};
</script>

<style scoped>
.overlay {
  /*要素を重ねた時の順番*/
  z-index: 4;
  /*画面全体を覆う設定*/
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
.overlay-body {
  background: white;
  margin: 100px 15px 0 15px;
  border-radius: 5px;
  height: 65%;
  padding: 15px;
}
p.frail-text {
  font-size: 2rem;
  color: #00a0b9;
  font-weight: 500;
}
.tap-contents {
  display: flex;
  margin: 40% 0 10% 0;
}
.tap-contents .btn-img img{
  width: 90%;
}

@keyframes move-y {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FrailCheckAlert.vue